var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaltSensitivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#225EA8;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#C6C6C5;}\n\t.st3{fill:#35B5BC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.8,82.4l-12.2,59.7h60.8l-12.2-59.7H87.8z M127.5,136.6H106H84.5h-2.5l10-49h13.9h0.1h13.9l10,49H127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.8,78.1H84.2l-13.9,68.4h71.5L127.8,78.1z M136.4,142.1H75.6l12.2-59.7h36.5L136.4,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126,76.4c0-9.6-7.8-17.3-17.3-17.3h-5.4C93.8,59,86,66.8,86,76.4v2.2h40V76.4z M117.3,68.3 c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9C115.4,69.2,116.3,68.3,117.3,68.3z M115.5,65.4 c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9C114.6,63.5,115.5,64.3,115.5,65.4z M109.7,68.3 c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9C107.8,69.2,108.7,68.3,109.7,68.3z M106,67.3c-1,0-1.9-0.8-1.9-1.9 c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9C107.9,66.4,107,67.3,106,67.3z M96.6,70.2c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9 c0-1,0.8-1.9,1.9-1.9C95.7,68.3,96.6,69.2,96.6,70.2z M98.5,63.5c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9 C96.6,64.3,97.5,63.5,98.5,63.5z M102.2,68.3c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9 C100.3,69.2,101.1,68.3,102.2,68.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 106,
    cy: 65.4,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 98.5,
    cy: 65.4,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 113.6,
    cy: 65.4,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 102.2,
    cy: 70.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.7,
    cy: 70.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.7,
    cy: 70.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 117.3,
    cy: 70.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.1,87.6h-0.1H92.1l-10,49h2.5H106h21.5h2.5l-10-49H106.1z M101.5,96.1c0.6,0,1.1,0.5,1.1,1.1 c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C100.4,96.6,100.9,96.1,101.5,96.1z M99.8,107.6c0,0.7-0.6,1.2-1.2,1.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C99.3,106.4,99.8,107,99.8,107.6z M97,100.3c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2 c0-0.7,0.5-1.2,1.2-1.2C96.4,99.1,97,99.7,97,100.3z M94.9,91.9c0.6,0,1,0.5,1,1s-0.5,1-1,1c-0.6,0-1-0.5-1-1S94.4,91.9,94.9,91.9z  M92.6,104.7c0.6,0,1,0.5,1,1s-0.5,1-1,1c-0.6,0-1-0.5-1-1S92,104.7,92.6,104.7z M89.3,131.3c-0.6,0-1-0.5-1-1s0.5-1,1-1 c0.6,0,1,0.5,1,1S89.9,131.3,89.3,131.3z M91.5,116.4c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1 C92.6,116,92.1,116.4,91.5,116.4z M94.7,126.8c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9 C96.6,126,95.7,126.8,94.7,126.8z M98.2,117c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4S98.9,117,98.2,117z  M101.3,132c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4S102,132,101.3,132z M102,124.2c-1.1,0-2-0.9-2-2 c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C104,123.3,103.1,124.2,102,124.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.7,
    cy: 124.9,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.5,114.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1C92.6,114.8,92.1,114.3,91.5,114.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 98.6,
    cy: 107.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.5,98.4c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1 C100.4,97.9,100.9,98.4,101.5,98.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.8,
    cy: 100.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 89.3,
    cy: 130.3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.3,129.2c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4S102,129.2,101.3,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,120.2c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C104,121.1,103.1,120.2,102,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,114.1c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4S98.9,114.1,98.2,114.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.6,
    cy: 105.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.9,
    cy: 92.9,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaltSensitivity);
export default __webpack_public_path__ + "static/media/Salt_Sensitivity.41f5599581e39732c4b563b040fc51ce.svg";
export { ForwardRef as ReactComponent };